import React, { Component } from 'react';
import { Card, CardBody } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';

class LabsTempletes extends Component {

    render() {
        return (
            <Card>
                <div className="form" style={{ flex: 1, flexDirection: 'column', display: 'flex' }}>
                    <div className="card__title">
                        <h5 className="bold-text">Resultados Examenes</h5>
                    </div>
                    <div style={{ flexDirection: 'row', display: 'flex' }}>
                        <div className="form__form-group">
                            <span className="form__form-group-label">Resultados</span>
                            <div className="form__form-group-field">

                                <textarea
                                    name="textarea-results-labs"
                                    defaultValue={this.props.data.results}
                                    onChange={(e) => { this.props.handlerLabsResults('results', e.target.value) }}
                                >
                                </textarea>
                            </div>
                        </div>
                        <div className="form__form-group" style={{ marginLeft: 15 }}>
                            <span className="form__form-group-label">Notas</span>
                            <div className="form__form-group-field">
                                <textarea
                                    name="textarea-notes-labs"
                                    defaultValue={this.props.data.notes}
                                    onChange={(e) => { this.props.handlerLabsResults('notes', e.target.value) }}
                                >
                                </textarea>

                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        );
    }
}

export default reduxForm({
    form: 'templetes_labs_form', // a unique identifier for this form
})(withTranslation('common')(LabsTempletes));